<template>
  <v-card
    class="ma-0 mt-0"
    width="100%"
    style="height: 440px;overflow-y: hidden !important;"
  >
    <v-app-bar
      flat
      class="my-0 mt-2 mb-2 py-1 px-4"
      dense
      height="20"
    >
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="sheet = true"
          >
            <v-icon
              x-small
              color="primary"
              style="font-size: 22px"
            >
              mdi-filter
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('filter') }} (f2)</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            v-bind="attrs"
            icon
            small
            class="mx-1"
            v-on="on"
            @click="productDialog = true"
          >
            <v-icon
              color="primary"
              medium
            >
              mdi-plus
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('new-product') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            v-bind="attrs"
            icon
            small
            class="mx-1"
            @click="selectByBarcode = !selectByBarcode"
            v-on="on"
          >
            <v-icon
              v-if="selectByBarcode"
              color="primary"
              medium
            >
              mdi-barcode
            </v-icon>
            <v-icon
              v-if="!selectByBarcode"
              medium
            >
              mdi-barcode-off
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('select-by-barcode') }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-row class="mx-1 mt-0 mb-0">
      <v-col
        class="py-0 px-2"
        cols="12"
      >
        <v-chip-group
          v-model="selectGroup"
          mandatory
          active-class="primary--text"
        >
          <v-chip
            v-for="(group, i) in groups"
            :key="i"
            :value="group"
          >
            {{ group.name }}
          </v-chip>
        </v-chip-group>
      </v-col>
      <v-col
        class=" px-2"
        cols="12"
      >
        <v-text-field
          ref="searchRef"
          v-model="search"
          append-icon="mdi-magnify"
          :label="$t('search')"
          solo
          autofocus
          flat
          height="30"
          :background-color="($vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5')"
          dense
          clearable
          :loading="loading"
        />
      </v-col>
    </v-row>
    <v-row class="mx-0 mt-0">
      <v-col
        cols="12"
        class="pt-0 px-0"
      >
        <v-list
          ref="scrollContainer"
          v-model="selected"
          nav
          dense
          class="overflow-y-auto px-0"
          :height="listHeight"
          style="overflow-x: hidden;min-height:360px"
        >
          <v-list-item v-if="showAlert && items.length == 0">
            <v-alert
              dense
              outlined
              style="width: 100%"
              class="py-0 my-0"
              type="error"
            >
              {{$t('alert-not-find-product')}}
            </v-alert>
          </v-list-item>
          <v-list-item
            v-for="(item, i) in items"
            :key="i"
            ref="test"
            :class="{ 'border-item' : item.selected}"
            class="my-0 py-0 ps-3 mb-2"
            style="box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05), 0 1px 10px 0 rgba(0, 0, 0, 0.1);"
          >
            <v-list-item-content
              style="cursor: pointer"
            >
              <v-list-item-title
                style="white-space: unset !important;"
                @click="add(item)"
              >
                {{ item.name }}
                <v-btn
                  class="ma-2"
                  color="primary"
                  outlined
                  x-small
                  icon
                >
                  <v-icon
                    dark
                  >
                    mdi-plus
                  </v-icon>
                </v-btn>
              </v-list-item-title>
              <v-list-item-subtitle v-if="item.type == 'product'">
                {{ (item.stock != undefined ? $t('stock')+' : '+item.stock.count + '  |  ' : '' ) }}  {{ $t('code')+ ' : '+ item.code + '  |  ' }}   {{ $t('unit')+ ' : '+ (item.unit ? item.unit.name : '') }}
              </v-list-item-subtitle>
              <v-list-item-subtitle v-if="item.type == 'service'">
                {{ $t('service') }}  {{ (item.unit != undefined ? '  |  '+ $t('unit')+ ' : '+ (item.unit ? item.unit.name : '') : '') }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action class="">
              <v-row
                class=" py-0 pl-4 mb-2"
                style="height: 25px"
              >
                <v-progress-circular
                  v-if="item.loading"
                  :size="20"
                  :width="2"
                  color="primary"
                  indeterminate
                />
                <v-col
                  v-if="item.price"
                  class="pt-0"
                >
                  {{ (item.price ? $numberFormat(item.price) + ' ' + $store.state.currency.name : '') }}
                </v-col>
              </v-row>
            </v-list-item-action>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <div
                v-if="more"
                v-observe-visibility="{
                    callback: visibilityChanged
                  }"
                class="text-center"
              >
                <v-progress-circular
                  :size="20"
                  :width="2"
                  color="primary"
                  indeterminate
                />
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
    <v-bottom-sheet v-model="sheet">
      <v-sheet
        class="text-center"
        height="300px"
      >
        <v-btn
          class="mt-6"
          text
          color="red"
          @click="sheet = !sheet"
        >
          {{ $t('close') }}
        </v-btn>
        <v-row class="mx-0">
          <v-col
            class="mb-0 pb-0 "
            style="height: 55px"
            cols="12"
            md="4"
            sm="4"
          >
            <aicomplete
              ref="refGroup"
              v-model="group"
              :val="group"
              title="main-group"
              type="productGroup"
              :data="JSON.stringify({parent:0})"
              :new-btn="true"
            />
          </v-col>
          <v-col
            class="mb-0 pb-0 "
            style="height: 55px"
            cols="12"
            md="4"
            sm="4"
          >
            <aicomplete
              ref="refCat1"
              v-model="cat1"
              :val="cat1"
              title="other-group"
              type="productGroup"
              :data="JSON.stringify({parent:(group?group.id:null)})"
              :new-btn="true"
            />
          </v-col>
          <v-col
            class="mb-0 pb-0 "
            style="height: 55px"
            cols="12"
            md="4"
            sm="4"
          >
            <aicomplete
              ref="refCat2"
              v-model="cat2"
              :val="cat2"
              title="category"
              type="productGroup"
              :data="JSON.stringify({parent:(cat1?cat1.id:null)})"
              :new-btn="true"
            />
          </v-col>
        </v-row>
        <!--        <v-row class="mx-0">-->
        <!--          <v-col-->
        <!--            cols="12"-->
        <!--            sm="1"-->
        <!--            class="mb-1"-->
        <!--            md="1"-->
        <!--          >-->
        <!--            <v-switch-->
        <!--              v-model="availableGoods"-->
        <!--              :label="$t('only-available-goods')"-->
        <!--            />-->
        <!--          </v-col>-->
        <!--        </v-row>-->
      </v-sheet>
    </v-bottom-sheet>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="productDialog"
      width="95%"
    >
      <v-card>
        <v-col class="d-flex pt-2 pb-0">
          <v-btn
            icon
            @click="productDialog = false"
          >
            <v-icon
              class="close-hover"
              large
              color="grey"
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-card-text class="pa-0">
          <div
            class="overflow-y-auto ma-2 mt-0"
            style=" height: 350px"
          >
            <product
              v-model="newProduct"
              form-type="product"
              @close="productDialog = false"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="(snakbarColor ? snakbarColor : 'primary')"
    />
  </v-card>
</template>

<script>
  import Product from '../../../pages/product/product'
  export default {
    components: {
      aicomplete: () => import('../AIcomplete/index'),
      Snakbar: () => import('../snakbar/snakbar'),
      Product,
    },
    props: ['header', 'customer', 'data'],
    data () {
      return {
        page: 1,
        selectByBarcode: true,
        last_page: 10000,
        options: {
          locale: 'en-US',
          prefix: '',
          suffix: '  ریال  ',
          precision: 0,
        },
        feeRules: [
          v => !!v || 'Name is required',
          v => (v && v > 0) || 'Name must be less than 10 characters',
        ],
        productTimer: 0,
        listHeight: 360,
        snakbarText: null,
        groups: null,
        selectGroup: null,
        showAlert: false,
        productDialog: false,
        disabled: false,
        taxDialog: false,
        snakbar: false,
        sumDiscountPercent: null,
        bottomPanel: null,
        date: null,
        snakbarColor: null,
        trip: {
          name: '',
          location: null,
          start: null,
          end: null,
        },
        locations: ['Australia', 'Barbados', 'Chile', 'Denmark', 'Ecuador', 'France'],
        items: [],
        bottomSummeryHeight: 'auto',
        selected: 0,
        selectedItem: [],
        searchTrigger: false,
        showSelectedItem: false,
        submitLoading: false,
        newProduct: null,
        group: null,
        cat1: null,
        cat2: null,
        search: null,
        list: null,
        type: 'productService',
        loading: false,
        sheet: false,
        bottomSummery: false,
        availableGoods: false,
        sumPrice: 0,
        sumDiscount: 0,
        sumTax: 0,
        more: true,
        tax: false,
        discountRules: [
          v => (v && v <= 100) || 'Max should not be above £50,000',
        ],
      }
    },
    watch: {
      selectGroup (Val, oldVal) {
        this.getItems()
        // if (this.$refs.refCat2 && this.$refs.refCat1) {
        //   if (Val) {
        //     this.$refs.refCat1.clear()
        //     this.$refs.refCat2.clear()
        //     this.$refs.refCat1.initList = false
        //     this.$refs.refCat1.getItems()
        //   } else {
        //     this.$refs.refCat1.clear()
        //     this.$refs.refCat2.clear()
        //   }
        // }
      },
      group (Val, oldVal) {
        if (this.$refs.refCat2 && this.$refs.refCat1) {
          if (Val) {
            this.$refs.refCat1.clear()
            this.$refs.refCat2.clear()
            this.$refs.refCat1.initList = false
            this.$refs.refCat1.getItems()
          } else {
            this.$refs.refCat1.clear()
            this.$refs.refCat2.clear()
          }
        }
      },
      cat1 (Val, oldVal) {
        if (this.$refs.refCat2) {
          if (Val) {
            this.$refs.refCat2.clear()
            this.$refs.refCat2.initList = false
            this.$refs.refCat2.getItems()
          } else {
            this.$refs.refCat2.clear()
          }
        }
      },
      data () {
      },
      newProduct  () {
        this.search = this.newProduct.name
        this.searchTrigger = true
        this.searchItems()
        this.productDialog = false
      },
      entrepot  () {
        this.search = ''
        // this.searchItems()
      },
      availableGoods () {
        this.items = []
        this.page = 1
        this.lastPage = 100000
        this.searchItems()
      },
      search (val, oldVal) {
        var app = this
        app.showAlert = false
        clearTimeout(this.productTimer)
        this.productTimer = setTimeout(function () {
          app.page = 1
          app.lastPage = 100000
          if (app.selectByBarcode && !app.search) {
          } else {
            if (app.selectByBarcode) {
              var index = app.items.findIndex(x => x.barcode === val)
              if (index === -1) {
                app.items = []
                app.more = true
                app.getItems()
              } else {
                setTimeout(function () {
                  app.search = null
                  app.add(app.items[index])
                }, 10)
              }
            } else {
              app.items = []
              app.more = true
              app.getItems()
            }
          }
        }, 30)
      },
      sheet () {
        if (this.sheet === false) {
          this.searchTrigger = true
          this.page = 1
          this.items = []
          this.lastPage = 100000
          this.initList = false
          this.getItems()
        }
      },
    },
    activated: function () {
      // this.countCheck()
    },
    mounted () {
      this.getGroups()
      // this.search = ''
    },
    beforeRouteLeave (to, from, next) {
      var goNext = false
      if (this.items) {
        this.items.map(function (value, key) {
          if (value.dialog) {
            value.dialog = false
            goNext = true
          }
        })
      }

      if (this.bottomPanel === 0) {
        this.bottomPanel = null
        goNext = true
      }
      if (!goNext) {
        next()
      } else {
        next(false)
      }
    },
    created () {
      // window.addEventListener('resize', this.resizeHeightBody)
    },
    destroyed () {
      // window.removeEventListener('resize', this.resizeHeightBody)
    },
    methods: {
      clearSearch () {
        this.initList = false
        this.getItems()
      },
      add (item) {
        this.$emit('append', item)
      },
      visibilityChanged (e) {
        e && this.getItems()
      },
      getItems () {
        var timeout = 1000
        if (this.selectByBarcode) {
          timeout = 50
        }
        this.loading = true
        this.showAlert = false
        if (this.page === 1 && this.search == null && this.initList && this.selectByBarcode) {
          return false
        }
        this.initList = true
        var app = this
        if (app.selectGroup) {
          app.items = []
          app.group = app.selectGroup
        }
        clearTimeout(this.productTimer)
        this.productTimer = setTimeout(function () {
          app.$axios.get(app.$endpoint + 'getdetail', {
            params: {
              search: app.search,
              page: app.options.page,
              select: 'productService',
              currency: app.currency,
              data: app.data,
              parent_id: app.parent,
              group: (app.group ? app.group.id : null),
              cat1: (app.cat1 ? app.cat1.id : null),
              cat2: (app.cat2 ? app.cat2 : null),
            },
          })
            .then(res => {
              res = res.data
              var setDef = false
              if (app.setInit && app.page === 1) {
                app.items = []
                setDef = true
              }
              app.last_page = res.last_page
              if (res.last_page > app.page) {
                app.page++
              }
              if (res.last_page === res.current_page) {
                app.last_page = 1
                app.more = false
              }
              // app.items = res.data
              app.items = [
                ...app.items,
                ...Array.from(res.data),
              ]
              if (setDef) {
                app.model = app.items[0]
              }
              if (res.data.length > 0) {
                app.notFind = null
                if (app.selectByBarcode && app.items.length === 1) {
                  app.add(app.items[0])
                  app.search = null
                }
              }
            })
            .catch(err => {
              this.serverErrorHandeler(err)
            })
            .finally(function () {
              app.disabled = false
              if (app.items.length === 0) {
                app.showAlert = true
                if (app.selectByBarcode) {
                  setTimeout(function () {
                    app.search = null
                  }, 1500)
                }
              }
              app.loading = false
            })
        }, timeout)
      },
      getGroups () {
        this.loading = true
        var app = this
        app.$axios.get(app.$endpoint + 'getdetail', {
          params: {
            search: app.search,
            select: 'allProductGroup',
          },
        })
          .then(res => {
            res = res.data
            app.groups = res
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(function () {
            app.disabled = false
            if (app.items.length === 0) {
              app.showAlert = true
              if (app.selectByBarcode) {
                setTimeout(function () {
                  app.search = null
                }, 1500)
              }
            }
            app.loading = false
          })
      },
    },
  }
</script>

<style>
  .dense > .v-input__control {
    min-height: 30px !important;
  }
  .border-item {
    border: #0066FF solid 1px;
  }
  .bottomSummery {
    position: fixed;
    height: auto;
    bottom: 0;
    width: 100%;
  }
</style>
